module.exports = __webpack_public_path__ + "img/category-page(infinite-scroll).ebe0b84a.jpg";